import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: block;
  text-align: center;
`;

const Image = styled.img`
  width: 200px;
  max-width: 100%;
`;

export default props => (
  <Container>
    <Image {...props} />
  </Container>
);
